<script setup lang="ts">
const { cart } = useCart();
const columns: TableColumn<CartItem>[] = [
  {
    key: "product",
    label: "Produit",
    flexGrow: true,
  },
  {
    key: "quantity",
    label: "Quantité",
    verticalAlign: "middle",
    width: "128px",
    mobileFullWidth: true,
  },
  {
    key: "subtotal",
    label: "Sous-total",
    verticalAlign: "middle",
    horizontalAlign: "right",
    mobileFullWidth: true,
  },
];
</script>

<template>
  <UiCheckoutStep :step="2" title="Votre commande">
    <UiResponsiveTable :columns="columns" :data="cart.cart_items">
      <template #product-cell="{ row }">
        <div class="flex items-center gap-4">
          <ProductThumbnail :product="row.product" class="shrink-0" />
          <div class="flex flex-col">
            <ProductName :product="row.product" />
            <CartItemDetails :cart-item="row" />
            <ProductPriceSimple v-if="row.product.price" :product="row.product" />
          </div>
        </div>
      </template>
      <template #quantity-cell="{ row }">
        <div class="text-lg font-bold">
          ×{{ integer(row.quantity) }}
        </div>
      </template>
      <template #subtotal-cell="{ row }">
        <div class="text-xl font-bold text-primary">
          {{ currency(row.subtotal) }}
        </div>
      </template>
    </UiResponsiveTable>
    <CartTotals />
  </UiCheckoutStep>
</template>
